import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatRadioChange } from "@angular/material";
import { CodeTable } from "src/app/core/model/v2/code-table";
import { GlobalHealthSystem } from "src/app/core/model/v2/healthSystem/global-health-system";
import { GlobalLocation } from "src/app/core/model/v2/healthSystem/global-location";
import { HealthSystemSetup } from "src/app/core/model/v2/practice/HealthSystemSetup";
import { CommonService } from "src/app/core/services/v2/common.service";
import { GlobalDataService } from "src/app/core/services/v2/global-data.service";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { SetupService } from "../../setup.service";

@Component({
  selector: "app-practices",
  templateUrl: "./practices.component.html",
  styleUrls: ["./practices.component.scss"],
})
export class PracticesComponent implements OnInit {
  @Input() hoType: number;
  @Input() healthSystem: HealthSystemSetup;
  @Output() toggleSidebar = new EventEmitter();

  @Output() save = new EventEmitter();
  statesCodes: CodeTable;
  isEditing = false;
  showWarning = false;
  showError = false;
  npi: string;
  errorMessage: string;
  id: number;
  practiceType: number;
  globalHealthSystem: GlobalHealthSystem;
  selectedMethod = "byNpi";
  practiceTypes: any[] = [
    {
      name: "Health",
      value: 0,
    },
    {
      name: "Case Management",
      value: 1,
    },
    {
      name: "Legal",
      value: 2,
    },
  ];

  constructor(
    private practiceService: PracticeService,
    private setupService: SetupService,
    private globalDataService: GlobalDataService,
    private loaderService: WindowLoaderService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.getSates();
    if (this.healthSystem) {
      this.isEditing = true;
      this.npi = this.healthSystem.npi;
      this.selectedMethod = this.npi ? "byNpi" : "manually";
      this.id = this.healthSystem.id;
      this.practiceType = this.healthSystem.practiceType;
      this.searchEdit();
    }
  }

  modeSelect(event: MatRadioChange) {
    if (event.value === "manually") {
      this.enterManually();
    } else {
      this.globalHealthSystem = undefined;
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  enterManually() {
    if (this.isEditing) return;

    this.isEditing = false;
    this.globalHealthSystem = new GlobalHealthSystem();
    this.globalHealthSystem.active = true;
    this.globalHealthSystem.location = new GlobalLocation();
    this.globalHealthSystem.practiceType = 0;
  }

  searchEdit() {
    this.loaderService.show();
    this.destroyComponentManually();

    this.practiceService
      .gethealthSystemDetails(this.id, this.practiceType)
      .subscribe(
        (response) => {
          if (response["response"]["isSuccess"]) {
            if (!response) {
              this.showWarning = true;
              return;
            }
            this.isEditing = true;
            this.globalHealthSystem = response;
          } else {
            this.showError = true;
          }
          this.loaderService.hide();
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }

  search() {
    if (this.isEditing) return;

    this.loaderService.show();
    this.destroyComponentManually();

    this.globalDataService.searchGlobalHealthSystem(this.npi).subscribe(
      (response) => {
        if (response["response"]["isSuccess"]) {
          response.id = 0; // used to indicated that this practitioner was retrieved from global
          if (!response) {
            this.showWarning = true;
            return;
          }
          this.isEditing = false;
          this.globalHealthSystem = response;
          this.globalHealthSystem.location.globalLocationId =
            this.globalHealthSystem.location.id;
        } else {
          this.showError = true;
        }
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  onSave(): void {
    if (!this.isEditing) {
      this.saveService();
    } else {
      this.updateService();
    }
  }

  getSates() {
    this.commonService.GetItemsByCodeNamesWithoutCache(["STATE"]).subscribe(
      (codeTables) => {
        this.statesCodes = codeTables.codeTable[0];
      },
      (error) => console.log(error)
    );
  }

  saveService() {
    this.loaderService.show();
    const precticesReq = {
      healthSystems: new Array<GlobalHealthSystem>(this.globalHealthSystem),
    };
    this.practiceService.addHealthSystemsToHO(precticesReq).subscribe(
      (response) => {
        if (response.isSuccess) {
          this.save.emit();
          this.closeSidebar();
        } else {
          this.errorMessage = "Error: " + response.message;
        }
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  updateService() {
    this.loaderService.show();
    this.practiceService.updateHealthSystem(this.globalHealthSystem).subscribe(
      (response) => {
        if (response.isSuccess) {
          this.save.emit();
          this.closeSidebar();
        } else {
          this.errorMessage = "Error: " + response.message;
        }
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  private destroyComponentManually() {
    this.isEditing = false;
    this.showWarning = false;
    this.showError = false;
    this.errorMessage = "";
    this.globalHealthSystem = undefined;
  }

  closeSidebar() {
    this.npi = "";
    this.destroyComponentManually();
    this.toggleSidebar.emit();
  }
}
